import React from 'react'
import PageConfig from '@/component/layout/PageConfig.tsx'
import { TYPE_TopNav } from '@/component/layout/TopNav/TopNav.tsx'
import Footer from '@/component/layout/Footer/Footer.tsx'

const TermsPage: React.FC = () => {
    return (
        <PageConfig showTopNav={true} typeTopNav={TYPE_TopNav.GUIDE}>
            <div className={'section_800 py-[60px] md:py-[30px] px-[24px]'}>
                <h1 className={'text-[28px] md:text-[22px] font-bold mb-[32px]'}>이용약관</h1>
                <p className={'text-[14px] text-gray4 leading-[1.8] mb-[32px]'}>
                    돌봄드림 주식회사(이하 "회사")가 제공하는 Carearly 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
                </p>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제1조 (목적)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        본 약관은 회사가 제공하는 Carearly 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항 및 기타 필요한 사항을 규정함을 목적으로 합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제2조 (용어의 정의)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>"서비스"란 회사가 제공하는 Carearly 및 관련 제반 서비스를 의미합니다.</li>
                        <li>"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
                        <li>"회원"이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</li>
                        <li>"보호 대상자"란 Carearly 서비스를 통해 위치 확인, 안전관리, 돌봄 모니터링 등의 대상이 되는 자를 의미합니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제3조 (약관의 효력 및 변경)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</li>
                        <li>회사는 관련 법령을 위반하지 않는 범위에서 본 약관을 변경할 수 있습니다.</li>
                        <li>회사가 약관을 변경할 경우 적용일자 및 변경사유를 명시하여 사전에 공지합니다.</li>
                        <li>이용자가 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 회원탈퇴를 요청할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제4조 (서비스의 제공)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 다음과 같은 서비스를 제공합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>보호 대상자 정보 관리</li>
                        <li>위치 기반 안전관리 서비스</li>
                        <li>보호자 알림 서비스</li>
                        <li>낙상 감지 및 위험상황 알림 서비스</li>
                        <li>돌봄 및 모니터링 관련 부가 서비스</li>
                        <li>기타 회사가 정하는 서비스</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제5조 (서비스 이용)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>서비스 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</li>
                        <li>회사는 시스템 점검, 교체, 장애, 통신두절 등 불가피한 사유가 있는 경우 서비스의 전부 또는 일부를 제한하거나 중단할 수 있습니다.</li>
                        <li>회사는 서비스의 내용, 운영상 또는 기술상 필요에 따라 제공 내용을 변경할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제6조 (회원가입 및 계정관리)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>이용자는 회사가 정한 절차에 따라 회원가입을 신청할 수 있습니다.</li>
                        <li>회사는 다음 각 호에 해당하는 경우 가입 신청을 승낙하지 않거나 사후에 이용계약을 해지할 수 있습니다.
                            <ol className={'list-decimal pl-[20px]'}>
                                <li>타인의 정보를 도용한 경우</li>
                                <li>허위 정보를 기재한 경우</li>
                                <li>법령 또는 공서양속에 반하는 목적으로 신청한 경우</li>
                                <li>기타 회사가 정한 요건을 충족하지 못한 경우</li>
                            </ol>
                        </li>
                        <li>이용자는 자신의 계정정보를 스스로 관리해야 하며, 이를 제3자에게 이용하게 하여서는 안 됩니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제7조 (이용자의 의무)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        이용자는 다음 행위를 하여서는 안 됩니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>허위정보의 등록</li>
                        <li>타인의 정보 도용</li>
                        <li>회사의 운영을 방해하는 행위</li>
                        <li>회사 및 제3자의 권리를 침해하는 행위</li>
                        <li>법령 및 공서양속에 반하는 행위</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제8조 (회사의 의무)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 관련 법령 및 본 약관이 정하는 바에 따라 지속적이고 안정적으로 서비스를 제공하기 위해 노력합니다.</li>
                        <li>회사는 이용자의 개인정보를 보호하기 위해 관련 법령이 정하는 바를 준수합니다.</li>
                        <li>회사는 서비스 이용과 관련하여 이용자가 제기한 정당한 의견이나 불만을 적절히 처리하도록 노력합니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제9조 (개인정보보호)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        회사는 이용자의 개인정보를 보호하기 위하여 관련 법령 및 회사의 개인정보처리방침을 따릅니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제10조 (면책)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중단, 기타 불가항력적 사유로 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.</li>
                        <li>회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.</li>
                        <li>회사는 본 서비스가 의료행위 또는 의료적 진단을 위한 서비스가 아님을 명확히 하며, 건강 상태에 대한 최종 판단은 의료전문가의 진단에 따라야 합니다.</li>
                        <li>회사는 이용자가 서비스를 통해 얻은 정보 또는 자료에 대한 신뢰 여부 및 이를 이용하여 발생한 손해에 대하여 책임을 지지 않습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제11조 (분쟁해결 및 관할)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사와 이용자 간 분쟁이 발생한 경우 상호 성실히 협의하여 해결하도록 노력합니다.</li>
                        <li>협의로 해결되지 않는 경우 관련 법령에 따른 법원을 관할법원으로 합니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제12조 (시행일)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        본 약관은 2024년 1월 1일부터 시행합니다.
                    </p>
                </section>
            </div>
            <Footer />
        </PageConfig>
    )
}

export default TermsPage
